import React from 'react';
import { Coffee } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useBreakReminder } from '../../contexts/BreakReminderContext';
import BreakEditor from '../../components/BreakReminder/BreakEditor';
import BreakReminderBentoGrid from '../../components/BreakReminder/BreakReminderBentoGrid';

const BreakReminderPage = () => {
  const { t } = useTranslation('breaks');
  const { breaks, selectedBreak } = useBreakReminder();

  return (
    <div className="h-full flex flex-col bg-white dark:bg-[var(--color-bg-base)]">
      {selectedBreak ? (
        <div className="flex-1 overflow-y-auto">
          <BreakEditor breakItem={selectedBreak} />
        </div>
      ) : breaks.length > 0 ? (
        <>
          <div className="flex-shrink-0 px-6 py-4 border-b border-slate-200 dark:border-white/10 bg-white dark:bg-[var(--color-bg-base)]">
            <p className="text-xs text-slate-500 dark:text-[var(--color-text-secondary)] mb-0.5">
              {t('page.breadcrumbApp')} <span className="mx-1">›</span> {t('page.breadcrumbBreak')}
            </p>
            <h1 className="text-xl font-bold text-slate-900 dark:text-white">
              {t('page.title')}
            </h1>
            <p className="text-sm text-slate-500 dark:text-[var(--color-text-secondary)] mt-1">
              {t('page.subtitle')}
            </p>
          </div>
          <BreakReminderBentoGrid />
        </>
      ) : (
        <div className="flex-1 flex items-center justify-center p-6">
          <div className="text-center text-slate-500 dark:text-[var(--color-text-secondary)]">
            <div className="w-20 h-20 rounded-full bg-slate-100 dark:bg-[var(--color-bg-elevated)] flex items-center justify-center mb-6 mx-auto border border-slate-200 dark:border-white/10">
              <Coffee className="w-10 h-10 text-slate-400 dark:text-[var(--color-text-secondary)]" strokeWidth={1.5} />
            </div>
            <h2 className="text-xl font-bold mb-2 text-slate-900 dark:text-white">{t('page.emptyTitle')}</h2>
            <p className="text-sm text-slate-500 dark:text-[var(--color-text-secondary)]">
              {t('page.emptyHint')}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default BreakReminderPage;
